import { Modal } from "antd";
import { ListingProperties } from "../../../types/listing.type";
import DetailListingInformation from "../../listing/DetailComponents/ListingInformation";

interface Props {
	open?: boolean;
	onClose?: () => void;
	listing?: ListingProperties;
}
const ListingModal: React.FC<Props> = ({ open, onClose, listing }) => {
	return (
		<Modal
			width={1145}
			footer={null}
			open={open}
			onCancel={onClose}
		>
			<DetailListingInformation
				isMinimal={true}
				listing={listing}
				listingId={listing?.listingId ?? ""}
				isHideListingPortal
			/>
		</Modal>
	);
};
export default ListingModal;
